import { render, staticRenderFns } from "./TemplatesConfigurationsTable.vue?vue&type=template&id=39372a4c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TemplatesConfigurationsTable.vue?vue&type=script&lang=js"
export * from "./TemplatesConfigurationsTable.vue?vue&type=script&lang=js"
import style0 from "./TemplatesConfigurationsTable.vue?vue&type=style&index=0&id=39372a4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39372a4c",
  null
  
)

export default component.exports